import { render, staticRenderFns } from "./ModalSupplies.vue?vue&type=template&id=37ffb2fb&lang=pug&"
import script from "./ModalSupplies.vue?vue&type=script&lang=js&"
export * from "./ModalSupplies.vue?vue&type=script&lang=js&"
import style0 from "./ModalSupplies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports